import "./App.css";
import "./Components/FontAwesome";
import Location from "./Pages/Location/Location";
import Login from "./Pages/Login/Login";
import SimpleMap from "./Pages/SimpleMap";
import AddStore from "./Pages/Store/AddStore";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useState } from "react";
import { Offline, Online, Detector } from "react-detect-offline";

function App() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  return (
    <div className="App">
      <Detector
        onChange={(e) => {
          setIsOnline(e);
        }}
        render={({ online }) => (
          <div className={online ? "normal" : "warning"}>
            You are currently {online ? "online" : "offline"}
          </div>
        )}
      />
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/location" element={<Location />} />
          <Route
            path="/store/add/:lat/:lng"
            element={<AddStore isOnline={isOnline} />}
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
